import { render, staticRenderFns } from "./column1.vue?vue&type=template&id=8c4015ca&scoped=true&"
import script from "./column1.vue?vue&type=script&lang=js&"
export * from "./column1.vue?vue&type=script&lang=js&"
import style0 from "./column1.vue?vue&type=style&index=0&id=8c4015ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4015ca",
  null
  
)

export default component.exports